/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Add_Event_NoneInputs */



/**
* | output |
* | --- |
* | "No events to link: you organize no tournament of this format outside a league. You can also link an event from its Set up tab." |
*
* @param {League_Add_Event_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_add_event_none = /** @type {((inputs?: League_Add_Event_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Add_Event_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun tournoi à lier : vous n'organisez aucun tournoi de ce format hors ligue. Vous pouvez aussi lier un tournoi depuis son onglet Préparation.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay torneos que vincular: no organiza ningún torneo de este formato fuera de una liga. También puede vincular un torneo desde su pestaña Preparación.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum torneio para vincular: você não organiza nenhum torneio deste formato fora de uma liga. Também pode vincular um torneio pela aba Preparação dele.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun torneo da collegare: non organizzi tornei di questo formato fuori da un campionato. Puoi anche collegare un torneo dalla sua scheda Preparazione.")
	return /** @type {LocalizedString} */ ("No events to link: you organize no tournament of this format outside a league. You can also link an event from its Set up tab.")
});